export default {"src":"/_next/static/media/gt.f781ceeb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};